// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1-Ceu","type":"styles_type__6evGV","choices":"styles_choices__s_atb"};